export default __webpack_public_path__ + "static/media/Woven_Forly.b868c0ca.svg";